// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8f2ab2a74220e07d3e48","883":"8edb778200e3d9d6d5d3"}[chunkId] + ".js";
};